import { isBrowser } from './is-browser';

type DeviceType = 'mobile' | 'tablet' | 'desktop';

export function getDeviceType(): DeviceType | undefined {
  if (!isBrowser) {
    return undefined;
  }
  const userAgent = window.navigator.userAgent;

  if (/iPad/i.test(userAgent)) {
    // ipad has mobile keyword
    return 'tablet';
  }

  if (
    /mobile/i.test(userAgent) ||
    /iPhone/i.test(userAgent) ||
    (/Android/i.test(userAgent) && window.innerWidth < 568)
  ) {
    return 'mobile';
  }

  if (
    /tablet/i.test(userAgent) ||
    /iPad/i.test(userAgent) ||
    /Android/i.test(userAgent)
  ) {
    return 'tablet';
  }

  return 'desktop';
}
